import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './ProfilesSection.css';

const ProfilesSection = ({ profiles, loading, error }) => {
  const { t, i18n } = useTranslation();
  
  if (loading) {
    return (
      <section className="profiles-section">
        <div className="profiles-container">
          <div className="loading-state">
            <div className="loading-spinner"></div>
            <p className="loading-text">{t('profiles.loadingFeatured', 'Loading featured profiles...')}</p>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="profiles-section">
        <div className="profiles-container">
          <div className="error-state">
            <div className="error-icon">⚠️</div>
            <p className="error-text">
              {t('profiles.errorFeatured', 'Error loading featured profiles:')} {error}
            </p>
          </div>
        </div>
      </section>
    );
  }

  if (!profiles || profiles.length === 0) {
    return (
      <section className="profiles-section">
        <div className="profiles-container">
          <div className="empty-state">
            <div className="empty-icon">💝</div>
            <p className="empty-text">
              {t('profiles.noFeatured', 'No featured profiles to display at the moment.')}
            </p>
          </div>
        </div>
      </section>
    );
  }
  
  // Single profile showcase design
  const profile = profiles[0];
  const imageUrl = profile.uploadedImages && profile.uploadedImages.length > 0
    ? profile.uploadedImages[0].url
    : '/assets/placeholder-profile.jpg';

  return (
    <section className="profiles-section">
      <div className="profiles-container">
        <div className="section-header">
          <div className="section-divider">
            <div className="divider-line"></div>
            <span className="divider-text">{t('profiles.badge', 'Демо Профил')}</span>
            <div className="divider-line"></div>
          </div>
          <h2 className="section-title">
            {t('profiles.demoTitle', 'Погледнете Пример Профил')}
          </h2>
          <p className="section-description">
            {t('profiles.demoDescription', 'Откријте како можете да создадете прекрасен дигитален споменик за вашите сакани.')}
          </p>
        </div>
        
        <div className="demo-profile-showcase">
          <Link 
            to={`/${i18n.language}/profile/${profile.stringId || profile.id}`} 
            className="demo-profile-card"
          >
            <div className="demo-profile-image-section">
              <div className="demo-image-wrapper">
                <img
                  src={imageUrl}
                  alt={profile.name}
                  className="demo-profile-image"
                />
                <div className="demo-image-overlay">
                  <div className="demo-overlay-content">
                    <span className="demo-view-icon">👁️</span>
                    <span className="demo-view-text">{t('profiles.viewDemo', 'Погледај Демо Профил')}</span>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="demo-profile-content">
              <div className="demo-profile-header">
                <div className="demo-profile-badge">
                  <span className="badge-icon">✨</span>
                  <span className="badge-text">{t('profiles.featured', 'Истакнат Профил')}</span>
                </div>
                <h3 className="demo-profile-name">{profile.name}</h3>
                <p className="demo-profile-years">
                  {profile.birthDate} — {profile.deathDate}
                </p>
              </div>
              
              <div className="demo-profile-intro">
                <p className="demo-intro-text">
                  {profile.introduction || t('profiles.noIntroduction', 'Посветена мајка, омилена баба и личност што ги допреше срцата на сите околу неа.')}
                </p>
              </div>
              
              <div className="demo-profile-features">
                <div className="demo-feature-item">
                  <span className="feature-icon">📸</span>
                  <span className="feature-text">
                    {profile.uploadedImages?.length || 0} {t('profiles.photos', 'Фотографии')}
                  </span>
                </div>
                <div className="demo-feature-item">
                  <span className="feature-icon">📍</span>
                  <span className="feature-text">
                    {profile.restingPlaceCity || t('profiles.location', 'Локација')}
                  </span>
                </div>
                <div className="demo-feature-item">
                  <span className="feature-icon">📖</span>
                  <span className="feature-text">
                    {t('profiles.lifeStory', 'Животна Приказна')}
                  </span>
                </div>
              </div>
              
              <div className="demo-profile-cta">
                <span className="cta-text">{t('profiles.clickToExplore', 'Кликни за да го разгледаш демо профилот')}</span>
                <span className="cta-arrow">→</span>
              </div>
            </div>
          </Link>
          
          <div className="demo-info-card">
            <div className="info-card-icon">💡</div>
            <h4 className="info-card-title">
              {t('profiles.createYourOwn', 'Креирајте Ваш Сопствен Профил')}
            </h4>
            <p className="info-card-description">
              {t('profiles.createDescription', 'Сочувајте ги спомените на вашите сакани со прекрасен дигитален профил. Споделете фотографии, приказни и локација на гробот.')}
            </p>
            <Link 
              to={`/${i18n.language}/create-profile`}
              className="info-card-button"
            >
              <span className="button-icon">✨</span>
              <span>{t('profiles.startCreating', 'Започни Сега')}</span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProfilesSection;
